<template>
  <v-btn
    :color="color"
    :disabled="disabled"
    @click="
      () => {
        $emit('click');
      }
    "
  >
    <v-icon>{{ leftSideIcon }}</v-icon>
    <span>{{ title }}</span>
    <v-icon>{{ rightSideIcon }}</v-icon>
  </v-btn>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    color: {
       type: String,
       default: ""
    },
    leftSideIcon: {
       type: String,
       default: ""
    },
    rightSideIcon: {
       type: String,
       default: ""
    },
  },
};
</script>
